module.exports = __webpack_public_path__ + "assets/img/24_1074_big.245a5890.jpg";